import { extendObservable } from 'mobx'
import { expertApi } from '@atheneum/api'

class PaymentDetailsStore {
  constructor (growlStore) {
    this.growlStore = growlStore

    extendObservable(this, {
      paymentDetails: null,
      loading: false,
      error: null,
      rejectionReasons: null
    })
  }

  init () {
    return this.loadRejectionReasons()
  }

  get (expertId) {
    this.loading = true
    return expertApi.getPaymentDetails(expertId)
      .then(paymentDetails => {
        this.paymentDetails = paymentDetails
        this.loading = false
      })
      .catch(err => {
        this.error = err
        this.loading = false
      })
  }

  loadRejectionReasons () {
    this.loading = true
    expertApi.getRejectionReasons()
      .then(rejectionReasons => {
        this.rejectionReasons = rejectionReasons
        this.loading = false
      })
      .catch(err => {
        this.error = err
        this.loading = false
      })
  }

  incompletePaymentDetails (payload) {
   expertApi.rejectPaymentDetails(payload)
      .then(() => this.handleSuccess('unconfirmed', payload.expertId))
      .catch(this.handleError)
  }

  confirm (id) {
    expertApi.confirmPaymentDetails(id)
      .then(() => this.handleSuccess('confirmed', id))
      .catch(this.handleError)
  }

  approve (id) {
    expertApi.approvePaymentDetails(id)
      .then(() => this.handleSuccess('approved', id))
      .catch(this.handleError)
  }

  handleSuccess = (text, id) => {
    this.growlStore.showSuccess(`Payment details ${text}!`)
    this.get(id)
    this.error = null
  }

  handleError = error => {
    this.error = error
    this.growlStore.showError(error)
  }
}

export default PaymentDetailsStore
